import type { UserEntity } from '@/domains/user/user.entity';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserStoreEntity, UserStoreRepository } from '../models';

const defaultUserState: UserStoreEntity = {
  apiData: null,
  searchQuery: '',
  isLoading: false,
};

export const useUserStore = create<UserStoreRepository>()(
  persist(
    (set, get) => ({
      ...defaultUserState,

      loadData: (apiResponse: UserEntity[]) => {
        const { apiData } = get();
        if (JSON.stringify(apiData) === JSON.stringify(apiResponse)) return;

        set({
          apiData: apiResponse,
          isLoading: false,
        });
      },

      setSearchQuery: (query: string) => {
        set({ searchQuery: query });
      },

      setLoading: (loading: boolean) => set({ isLoading: loading }),

      clearUsers: () => set({ ...defaultUserState }),
    }),
    {
      name: '@app/users',
      partialize: (state: UserStoreRepository) => ({
        searchQuery: state.searchQuery,
      }),
    },
  ),
);
